import { render, staticRenderFns } from "./CreateUblArchiveModal.vue?vue&type=template&id=72a2bd06"
import script from "./CreateUblArchiveModal.vue?vue&type=script&lang=ts"
export * from "./CreateUblArchiveModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72a2bd06')) {
      api.createRecord('72a2bd06', component.options)
    } else {
      api.reload('72a2bd06', component.options)
    }
    module.hot.accept("./CreateUblArchiveModal.vue?vue&type=template&id=72a2bd06", function () {
      api.rerender('72a2bd06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/CreateUblArchiveModal.vue"
export default component.exports